import React from "react"

import styles from "./articleNews.module.scss"

function ArticleNews(props) {
  return (
    <>
      <div className={"col col-8 col-m-11 col-s-12"}>
        <a href={props.link.url} target="_blank" rel="noopener noreferrer">
          <div className={styles.articlelNews}>
            <div className={'flex middle center ' + styles.content}>

              <div className={'col col-x2 col-s-x1 ' + styles.preview}>
                <div
                  className={'bg bg-img ' + styles.image}
                  style={{ backgroundImage: "url(" + props.image.url + ")" }}
                ></div>
              </div>

              <div className={'col col-x2 col-s-x1 ' + styles.info}>
                <h2
                  className={styles.title}
                  dangerouslySetInnerHTML={{ __html: props.title }}
                ></h2>
                <p
                  className={styles.excerpt}
                  dangerouslySetInnerHTML={{ __html: props.excerpt }}
                ></p>

                <div className={styles.link}>
                  <a href={props.link.url} target="_blank" rel="noopener noreferrer">
                    {props.link.name}
                  </a>
                </div>
              </div>

            </div>
          </div>
        </a>
      </div>
    </>
  )
}
export default ArticleNews
